import AppIcon from "@/app/components/atomic/AppIcon";

export default function ChevronIcon({open, className}: { open: boolean; className?: string }) {
    return (
        <AppIcon
            iconClassName="fa-chevron-down"
            size="sm"
            type="regular"
            className={`transition-transform duration-300 ${open ? "rotate-180" : ""} ${className ?? ""}`}
        />
    );
}
